import { VisitDocumentTemplateMetadata } from '@dreryk/egabinet-visit-frontend-api';

const getFirstLetter = (name: string): string => {
   return name.trim().charAt(0).toUpperCase();
};

export const resolveLetterSeparator = (currentPage: VisitDocumentTemplateMetadata[], index: number): string | null => {
   const current = currentPage[index];
   if (!current) {
      return null;
   }

   const currentLetter = getFirstLetter(current.name);
   const previous = currentPage[index - 1];
   if (!previous) {
      return currentLetter;
   }

   return getFirstLetter(previous.name) === currentLetter ? null : currentLetter;
};
